import React from "react";

const TicketSkeleton = () => {
  return (
    <div>
      <h4 className="loading-custom h-106 mb-4 "></h4>
      <h4 className="loading-custom h-106 mb-4 "></h4>
      <div className="loading-custom h-screen"></div>
    </div>
  );
};

export default TicketSkeleton;
